module.exports = __webpack_public_path__ + "static/media/download.d3d6f8ee.svg";